
<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">チャージ項目詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="save" v-permit.SHARP_CI_NEW>{{
          $t('app.buttons.save')
        }}</v-btn>
        <v-btn @click="$router.go(-1)">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs6>
              <v-text-field
                clearable
                label="チャージCD"
                required
                v-model="form.code"
              />
              <v-text-field
                clearable
                label="チャージ名"
                required
                v-model="form.name"
              />
              <v-text-field
                clearable
                label="チャージ項目英語名称"
                required
                v-model="form.englishName"
              />
              <remote-select
                label="チャージ区分"
                required
                url="charge-item-type/kv"
                v-model="form.typeId"
              />
              <remote-select
                label="諸掛区分"
                required
                url="charge-item-sub-type/kv"
                v-if="form.typeId === 'CHARGE_ITEM_TYPE-VARIOUS_TIMES'"
                v-model="form.subTypeId"
              />
              <remote-select
                label="運送形態"
                required
                url="transport-modes/charge-items/kv"
                v-model="form.transportModeId"
              />

              <v-select
                :items="stackTypes"
                clearable
                label="STACK TYPE"
                v-model="form.stackType"
              />
              <v-flex md3 sm6 xs12>
                <remote-autocomplete
                  clearable
                  label="消費税 種類"
                  url="/tax-types/kv"
                  v-model="form.taxTypeId"
                />
              </v-flex>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                clearable
                label="诸掛画面統計項目"
                required
                v-model="form.screenStatistics"
              />
              <v-layout align-center>
                <div class="mr-1" style="width: 60px; color: #666">
                  課金単位
                </div>

                <v-checkbox
                  :key="unit.id"
                  :label="unit.text"
                  :value="unit.value"
                  class="shrink mr-2"
                  multiple
                  v-for="unit in units"
                  v-model="form.units"
                />
              </v-layout>
              <v-layout align-center>
                <div class="mr-1" style="width: 60px; color: #666">建値</div>
                <v-checkbox
                  :key="incoterm.id"
                  :label="incoterm.text"
                  :value="incoterm.value"
                  class="shrink mr-2"
                  multiple
                  v-for="incoterm in incoterms"
                  v-model="form.incoterms"
                />
              </v-layout>
              <v-layout align-center>
                <v-text-field
                  clearable
                  label="Sea请求code"
                  required
                  v-model="form.seaRequestCode"
                />
              </v-layout>
              <v-layout align-center>
                <v-text-field
                  clearable
                  label="Sea支付code"
                  required
                  v-model="form.seaPaymentCode"
                />
              </v-layout>
              <v-layout align-center>
                <v-text-field
                  clearable
                  label="Air请求code"
                  required
                  v-model="form.airRequestCode"
                />
              </v-layout>
              <v-layout align-center>
                <v-text-field
                  clearable
                  label="Air支付code"
                  required
                  v-model="form.airPaymentCode"
                />
              </v-layout>
              <v-layout align-center>
                <v-text-field
                  clearable
                  label="標準費用項目code（JusFin用）"
                  required
                  v-model="form.jusdaChargeCode"
                />
              </v-layout>
              <v-layout align-center>
                <div class="mr-1" style="width: 60px; color: #666">
                  手动输入
                </div>
                <v-checkbox
                  class="shrink mr-2"
                  v-model="form.isAdditionalCharge"
                />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      valid: true,
      form: {
        name: null,
        units: [],
        incoterms: [],
      },
      units: [],
      incoterms: [],
      nameRules: [(v) => !!v || 'Name is required'],
      stackTypes: ['FCL', 'LCL'],
    }
  },
  mounted() {
    this.$http.get('/incoterms/kv').then((res) => {
      this.incoterms = res.data
    })
    this.$http.get('/record-units/kv').then((res) => {
      this.units = res.data
    })
  },
  methods: {
    save() {
      let data = {
        ...this.form,
        incoterms: this.form.incoterms.map((i) => ({ id: i })),
        recordUnits: this.form.units.map((u) => ({ id: u })),
      }
      delete data.units
      this.$http.post('/charge-items', data).then(() => {
        this.$router.go(-1)
      })
    },
  },
}
</script>
